import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { PopUp } from './components/popUp/popUp';
import { Routes } from './components/routes';

class App extends React.Component{
  render(){
    return <Router>
      <PopUp />
      <Routes />
    </Router>
  }
}

export default App;
